import { addMonths, getDateString } from "@caprikorn/dynamo-utils";

import type { BillPaymentStatus } from "@services/apiEcms/apiEcms.types";

export const BILL_PAYMENT_STATUSES: BillPaymentStatus[] = [
  "PAID",
  "NOT_PAID",
  "PARTIALLY_PAID",
];

const DEFAULT_READING_PERIOD_MONTHS = 13;

export const getDefaultDateRange = () => {
  const today = getDateString(new Date());
  const startDate = addMonths(today, -DEFAULT_READING_PERIOD_MONTHS);
  return [startDate.substring(0, 7), today.substring(0, 7)];
};
